import React, { Component } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { Layer, Stage, Circle, Image, Line, Text, Rect, Arrow } from 'react-konva';
import { connect } from 'react-redux';
import axios from "axios";
import _ from 'lodash';
import LocalizedStrings from 'react-localization';
import { data } from '../js/data.js';
import { fontSizeToggleAction } from '../js/actions/fontSizeToggleAction'
import '../css/map.css';

let strings = new LocalizedStrings(data);

var imageURL = '';
var lastDist = 0;
var startingFloorIndex = ''
var startindIndex = ''
var destFloorIndex = '';
var destIndex = '';
var floorDest = '';
var floorDestId = '';
var nextStartingId = '';
var destFloorNum = '';
var startingX = '';
var startingY = '';
var nextFloorNum = '';
var destId = '';
var destType = ''

function calcDistance(starting, neighbour){
    var distance = Math.sqrt(Math.pow(starting.x-neighbour.x, 2)+Math.pow(starting.y-neighbour.y, 2));
    return distance;
}

function getDistance(p1, p2) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}

class NextPage extends Component {
    state = {
        position: 0,
        positions:[],
        starting: '',
        dest: '',
        image:new window.Image(),
        startingX: '',
        startingY: '',
        destX: '',
        destY: '',
        nodes: [],
        stageScale: 1.8,
        stageX: 100,
        stageY: -250,
        dummy:[],
        currentImage: '',
        floorDest: '',
        floorDestId:'ended',
        destId:'',
        nextStartingId:'',
        floorDestX: '',
        floorDestY: '',
        destImgURL: '',
        elevatorImgURL: ''
    }

    async componentDidMount(){
        await axios.get(`https://bcitrch-go.herokuapp.com/GetMapList`, {
            headers: {
                'Content-Type': 'text/plain;charset=utf-8'
            }
        })
            .then(res => {
                _.each(res.data.message.mapList, (item, index) => {
                    item.id = index;
                    this.setState({
                        dummy: [...this.state.dummy, item]
                    });
                });


        });
        this.loadImage();
        this.saveState();
        this.handlingElevator();
        await this.findRoute();
    }

    loadImage(){
        let id = this.props.match.params.map_id;
        var positions = this.props.maps;

        var startingId = '';
        for(var i = 0; i<id.length-1; i++){
            if(id[i] == "&"){
                break;
            }
            startingId += id[i];
        }
        for(var i = 0; i<positions.length; i++){
            for(var j = 0; j<positions[i].nodes.length; j++){
                if(positions[i].nodes[j].nodeId == startingId){
                    imageURL = positions[i].selectedPic
                }
            }
        }


        const image = new window.Image();
        image.src = imageURL;
        image.onload = () => {
            this.setState({
                image: image
            });
        };

        const imageCurrentLocation = new window.Image();
        imageCurrentLocation.src = "https://firebasestorage.googleapis.com/v0/b/bcitrch-3f6cb.appspot.com/o/86fd17769a3b2537d2b028601cda7b92.png?alt=media&token=ecb11290-8037-4890-a4d8-3107154308b4";
        imageCurrentLocation.onload = () => {
            this.setState({
                currentImage: imageCurrentLocation
            });
        };

        const destinationImg = new window.Image();
        destinationImg.src = "https://firebasestorage.googleapis.com/v0/b/bcitrch-3f6cb.appspot.com/o/destination.png?alt=media&token=809547e1-7f93-4b98-b3f6-d9c94573c2a3";
        destinationImg.onload = () => {
            this.setState({
                destImgURL: destinationImg
            });
        };

        const elevImg = new window.Image();
        elevImg.src = "https://firebasestorage.googleapis.com/v0/b/bcitrch-3f6cb.appspot.com/o/elevator%20(1).png?alt=media&token=f852ebf4-5bfb-4922-9026-507bc316320a";
        elevImg.onload = () => {
            this.setState({
                elevatorImgURL: elevImg
            });
        };
        
    }


    saveState() {
        let id = this.props.match.params.map_id;
        var positions = this.props.maps;
        var startingId = '';
        for(var i = 0; i<id.length-1; i++){
            if(id[i] == "&"){
                break;
            }
            startingId += id[i];
        }
        var starting = '';
        for(var i = 0; i<positions.length; i++){
            for(var j = 0; j<positions[i].nodes.length; j++){
                if(positions[i].nodes[j].nodeId == startingId){
                    starting = positions[i].nodes[j].name;
                    startingX=positions[i].nodes[j].x
                    startingY=positions[i].nodes[j].y
                    imageURL = positions[i].selectedPic
                    startingFloorIndex = i;
                    startindIndex = j;
                }
            }
        }
        var destX = '';
        var destY = '';
        var dest = '';
        for(var j = id.length-1; j>=0; j--){
            if(id[j] == "&"){
                break;
            }
            dest += id[j];
        }
        var newDestId = "";
        for (var i = dest.length - 1; i >= 0; i--) {
            newDestId += dest[i];
        }
        var newDest = "";
        for(var i = 0; i<positions.length; i++){
            for(var j = 0; j<positions[i].nodes.length; j++){
                if(positions[i].nodes[j].nodeId == newDestId){
                    newDest = positions[i].nodes[j].name;
                    destX=positions[i].nodes[j].x;
                    destY=positions[i].nodes[j].y;
                    destFloorIndex = i;
                    destIndex = j;
                    destFloorNum = positions[i].floorNum;
                    destId = positions[i].nodes[j].nodeId;
                    this.setState({
                        destId: positions[i].nodes[j].nodeId,
                    })
                }
            }
        }
        this.setState({
            starting: starting,
            dest: newDest,
            startingX: startingX,
            startingY: startingY,
            destX: destX,
            destY: destY,
        })
    }

    handlingElevator(){
        var position = this.props.maps
        for(var x = 0; x<position.length; x++){
            for(var i =0; i<position[x].nodes.length; i++){
                if(position[x].nodes[i].type == 'elevator'){
                    for(var j=0; j<position[x].nodes[i].elevatorList.length; j++){
                        position[x].nodes[i].adjacentNodes.push(position[x].nodes[i].elevatorList[j].value)
                    }
                }
            }
        }
    }

    findRoute(){
        var position = this.props.maps
        for(var x=0; x<position.length; x++){
            for(var i =0; i < position[x].nodes.length; i++){
                var q = 0;
                var nb = [];
                for(; q < position[x].nodes[i].adjacentNodes.length; q++){
                    var first='';
                    var distance = 0;
                    for(var n=0; n<position.length; n++){
                        for(var k =0; k < position[n].nodes.length; k++){
                            if(position[n].nodes[k].nodeId == position[x].nodes[i].adjacentNodes[q]){
                                if(position[x].nodes[i].adjacentNodes[q] === '' || position[x].nodes[i].adjacentNodes[q] === ' '){
                                    break;
                                } else {
                                    distance = calcDistance(position[x].nodes[i], position[n].nodes[k]);
                                    first = position[n].nodes[k].nodeId
                                }
                            } 
                        }
                    }   
                    nb[first] = distance
                }
                position[x].nodes[i].adjacentNode = nb;
            }
        }
        const Graph = require('node-dijkstra')
        const route = new Graph();
        for(var x=0; x<position.length; x++){
            for(var i = 0; i < position[x].nodes.length; i++){
                route.addNode(position[x].nodes[i].nodeId, position[x].nodes[i].adjacentNode)
            }
        }
        var shortestRoute = route.path(position[startingFloorIndex].nodes[startindIndex].nodeId, position[destFloorIndex].nodes[destIndex].nodeId)
        var coordinate = [];
        var floorDestX = '';
        var floorDestY = '';
        
        outerloop: for(var i = 0; i < shortestRoute.length; i++){
            for(var x=0; x<position.length; x++){
                for(var j=0; j<position[x].nodes.length; j++){
                    if(shortestRoute[i] == position[x].nodes[j].nodeId){
                        coordinate.push(position[x].nodes[j].x);
                        coordinate.push(position[x].nodes[j].y);
                        floorDestId = position[x].nodes[j].nodeId;
                        destType = position[x].nodes[j].type;
                        if(position[x].nodes[j].type == 'elevator' && i != 0){
                            floorDest = position[x].nodes[j].name;
                            nextStartingId = shortestRoute[i+1];
                            floorDestX = position[x].nodes[j].x;
                            floorDestY = position[x].nodes[j].y
                            break outerloop;
                        }
                    }
                }
            }
        }
        for(var x=0; x<position.length; x++){
            for(var j=0; j<position[x].nodes.length; j++){
                if(nextStartingId == position[x].nodes[j].nodeId){
                    nextFloorNum = position[x].floorNum;
                }
            }
        }
        this.setState({
            nodes: coordinate,
            floorDest: floorDest,
            floorDestId: floorDestId,
            nextStartingId: nextStartingId,
            floorDestX: floorDestX,
            floorDestY: floorDestY

        })
 
    }

    handleWheel = e => {
        e.evt.preventDefault();
        const scaleBy = 1.30;
        const stage = e.target.getStage();
        const oldScale = stage.scaleX();
        const mousePointTo = {
          x: stage.getPointerPosition().x / oldScale - stage.x() / oldScale,
          y: stage.getPointerPosition().y / oldScale - stage.y() / oldScale
        };
        const newScale = e.evt.deltaY > 0 ? oldScale / scaleBy : oldScale * scaleBy;

        stage.scale({ x: newScale, y: newScale });
    
        this.setState({
          stageScale: newScale,
          stageX:
            -(mousePointTo.x - stage.getPointerPosition().x / newScale) * newScale,
          stageY:
            -(mousePointTo.y - stage.getPointerPosition().y / newScale) * newScale
        });
    }

    handleTouchZoom = e =>{
        e.evt.preventDefault();
        const scaleBy = 1.05;
        const stage = e.target.getStage();

        stage.getContent().addEventListener(
            'touchmove',
            function(evt) {
              var touch1 = evt.touches[0];
              var touch2 = evt.touches[1];
    
              if (touch1 && touch2) {
                var dist = getDistance(
                  {
                    x: touch1.clientX,
                    y: touch1.clientY
                  },
                  {
                    x: touch2.clientX,
                    y: touch2.clientY
                  }
                );
    
                if (!lastDist) {
                  lastDist = dist;
                }
    
                var scale = (stage.scaleX() * dist) / (lastDist);
                stage.scale({ x: scale, y: scale });
                stage.scaleX(scale);
                stage.scaleY(scale);

                lastDist = dist;
              }
            },
            false
        )
            

        stage.getContent().addEventListener(
            'touchend',
            function() {
              lastDist = 0;
            },
            false
          );
    }


    render() {
        strings.setLanguage(this.props.languages);
        let destImage;
        let nextButton;
        if(destType == 'elevator'){
            destImage = 
            <Image 
                image = {this.state.elevatorImgURL}
                x={this.state.floorDestX-6} 
                y={this.state.floorDestY-9}
                scaleX={0.06}
                scaleY={0.06}
            />
        } else {
            destImage = 
            <Image 
                image = {this.state.destImgURL}
                x={this.state.destX-3} 
                y={this.state.destY-20}
                scaleX={0.04}
                scaleY={0.04}
            />
        }
        if(floorDestId != destId){
            nextButton = 
            <Link to={"/map/"+nextStartingId+"&"+this.state.destId}>
                <Button id={(this.props.isFontSizeEnabled ? 'map-home-button-large' : 'map-home-button')}
                        // class="btn-large btn-dir btn-blue btn-moveup"
                        node="a"
                        waves="light"
                        large
                    >
                    {strings.next}
                </Button>
            </Link>
        }
        return (
            <div className="App">

                <Stage width={window.innerWidth} height={window.innerHeight-(window.innerHeight*0.35)} draggable
                    onWheel={this.handleWheel}
                    onTouchMove={this.handleTouchZoom}
                    scaleX={this.state.stageScale}
                    scaleY={this.state.stageScale}
                    x={this.state.stageX}
                    y={this.state.stageY}
                >
                    <Layer>
                        <Image 
                            scaleX={0.26}
                            scaleY={0.26}
                            image = {this.state.image}  
                            x={-123} y={127}
                        />
                        <Rect 
                            x={this.state.floorDestX+6}
                            y={this.state.floorDestY-7}
                            fill='white'
                            width={51}
                            height={16}
                        />
                        <Text 
                            x={this.state.floorDestX+6}
                            y={this.state.floorDestY-6}
                            text={strings.takeElevator + ' ' + nextFloorNum + 'F'}
                            fontSize={7}
                            fill='black'
                            width={51}
                        />
                        {destImage}
                        <Image 
                            scaleX={0.04}
                            scaleY={0.04}
                            x={this.state.startingX-10} y={this.state.startingY-16}
                            image = {this.state.currentImage}
                        />
                        <Arrow
                            points={this.state.nodes}
                            tension={0}
                            stroke={'black'}
                            fill={'red'}
                            strokeWidth= {1.0}
                            pointerLength= {5}
                            pointerWidth= {5}
                        />
                    </Layer>
                </Stage>
                
                <div>
                    <div>
                        <h5>{strings.currentLocation}: <span id="starting">{this.state.starting}</span></h5>
                        <h5>{strings.destination}: <span id="end">{this.state.dest + " " + destFloorNum + "F"}</span></h5>
                    </div>
                    {nextButton}
                    <div id="button-home">
                        <Link to="/">
                            <Button id={(this.props.isFontSizeEnabled ? 'map-home-button-large' : 'map-home-button')}
                                // class="btn-large btn-dir btn-blue btn-moveup"
                                node="a"
                                waves="light"
                                large
                                style={{ marginBottom: '10px' }}
                            >
                                {strings.home}
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>

        )
    }
}
const mapStateToProps = (state) => {
    return {
        maps: state.maps.maps,
        isFontSizeEnabled: state.isFontSizeEnabled.isFontSizeEnabled,
        languages: state.language.language
    }
}

const mapDispatchToProps = dispatch => ({
    fontSizeToggleAction: () => dispatch(fontSizeToggleAction),
  });

export default connect(mapStateToProps, mapDispatchToProps)(NextPage);